import { Link } from 'react-router-dom';

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      {/* Header */}
      <header className="border-b border-white/10 bg-black/40 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-lg bg-[#FFD700] flex items-center justify-center">
                <span className="text-black font-bold text-xl font-['Outfit']">C</span>
              </div>
              <span className="text-xl font-bold text-white font-['Outfit']">
                Crack<span className="text-[#FFD700]">Box</span>
              </span>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6">
        <div className="text-center text-sm text-zinc-500">
          &copy; {new Date().getFullYear()} CrackBox. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
